import { useContext, useState } from "react";
import { Link } from "react-router-dom";

import { ThemeContext } from "../../../context/ThemeContext";
import logo from "../../../assets/images/logo.jpeg";

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { openMenuToggle } = useContext(ThemeContext);

  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        <img src={logo} alt="" height="100" />
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
